import { Navigate } from "react-router-dom";
import { PAGE_TITLES } from "@miplatform/constants";
import { AddAdders } from "../../views/Estimating/Configuration/Adders/AddAdders/AddAdders";
import { Adders } from "../../views/Estimating/Configuration/Adders/Adders";
import { AddAreaType } from "../../views/Estimating/Configuration/AreaTypes/AddAreaType/AddAreaType";
import { AreaTypes } from "../../views/Estimating/Configuration/AreaTypes/AreaTypes";
import { AddAttributes } from "../../views/Estimating/Configuration/Attributes/AddAttributes/AddAttributes";
import { Attributes } from "../../views/Estimating/Configuration/Attributes/Attributes";
import { AddCategories } from "../../views/Estimating/Configuration/Categories/AddCategories/AddCategories";
import { Categories } from "../../views/Estimating/Configuration/Categories/Categories";
import { AddItems } from "../../views/Estimating/Configuration/Items/AddItems/AddItems";
import { Items } from "../../views/Estimating/Configuration/Items/Items";
import { AddSpecSheet } from "../../views/Estimating/Plans/PlanDetail/AddSpecSheet/AddSpecSheet";
import { ImportPlanReview } from "../../views/Estimating/Plans/PlanDetail/ImportPlanReview/ImportPlanReview";
import { PlanDetail } from "../../views/Estimating/Plans/PlanDetail/PlanDetail";
import { PlanSeriesCommunitiesDetail } from "../../views/Estimating/Plans/PlanDetail/PlanSeriesCommunitiesDetail/PlanSeriesCommunitiesDetail";
import { Plans } from "../../views/Estimating/Plans/Plans";
import { CustomerPricingDetails } from "../../views/Estimating/Pricing/Customers/CustomerPricingDetails/CustomerPricingDetails";
import { Customers } from "../../views/Estimating/Pricing/Customers/Customers";
import { AddDropType } from "../../views/Estimating/Pricing/DropTypes/AddDropType/AddDropType";
import { DropTypes } from "../../views/Estimating/Pricing/DropTypes/DropTypes";
import { PricingMatrix } from "../../views/Estimating/Pricing/PricingMatrix/PricingMatrix";

export const estimatingRoutes = [
  // CONFIGURATION
  {
    path: "/estimating/configuration",
    name: "Configuration",
    exact: true,
    element: <Navigate to="items" replace />,
  },
  {
    path: "/estimating/configuration/items",
    name: "Items",
    element: <Items />,
    handle: { title: PAGE_TITLES.ITEMS },
  },
  {
    path: "/estimating/configuration/categories",
    name: "Categories",
    element: <Categories />,
    handle: { title: PAGE_TITLES.CATEGORIES },
  },
  {
    path: "/estimating/configuration/attributes",
    name: "Attributes",
    element: <Attributes />,
    handle: { title: PAGE_TITLES.ATTRIBUTES },
  },
  {
    path: "/estimating/configuration/area-types",
    name: "Area Types",
    element: <AreaTypes />,
    handle: { title: PAGE_TITLES.AREAS },
  },
  {
    path: "/estimating/configuration/adders",
    name: "Adders",
    element: <Adders />,
    handle: { title: PAGE_TITLES.ADDERS },
  },
  {
    path: "/estimating/configuration/add-items",
    name: "Add Items",
    element: <AddItems />,
    handle: { title: PAGE_TITLES.ADD_ITEM },
  },
  {
    path: "/estimating/configuration/items/:id",
    name: "Edit Items",
    element: <AddItems />,
    handle: { title: PAGE_TITLES.ITEM },
  },
  {
    path: "/estimating/configuration/add-categories",
    name: "Add Categories",
    element: <AddCategories />,
    handle: { title: PAGE_TITLES.ADD_CATEGORY },
  },
  {
    path: "/estimating/configuration/categories/:id",
    name: "Edit Categories",
    element: <AddCategories />,
    handle: { title: PAGE_TITLES.CATEGORY },
  },
  {
    path: "/estimating/configuration/add-attributes",
    name: "Add Attributes",
    element: <AddAttributes />,
    handle: { title: PAGE_TITLES.ADD_ATTRIBUTE },
  },
  {
    path: "/estimating/configuration/attributes/:id",
    name: "Edit Attributes",
    element: <AddAttributes />,
    handle: { title: PAGE_TITLES.ATTRIBUTE },
  },
  {
    path: "/estimating/configuration/add-area-types",
    exact: true,
    name: "Add Area Type",
    element: <AddAreaType />,
    handle: { title: PAGE_TITLES.ADD_AREA },
  },
  {
    path: "/estimating/configuration/area-types/:id",
    exact: true,
    name: "Edit Area Type",
    element: <AddAreaType />,
    handle: { title: PAGE_TITLES.AREA },
  },
  {
    path: "/estimating/configuration/add-adders",
    name: "Add Adders",
    element: <AddAdders />,
    handle: { title: PAGE_TITLES.ADD_ADDER },
  },
  {
    path: "/estimating/configuration/adders/:id",
    name: "Edit Adders",
    element: <AddAdders />,
    handle: { title: PAGE_TITLES.ADDER },
  },
  // PRICING
  {
    path: "/estimating/pricing",
    name: "Pricing",
    exact: true,
    element: <Navigate to="customers" replace />,
  },
  {
    path: "/estimating/pricing/customers",
    name: "Customers",
    element: <Customers />,
    handle: { title: PAGE_TITLES.PRICING },
  },
  {
    path: "/estimating/pricing/customers/:id",
    name: "Customer Pricing",
    element: <CustomerPricingDetails />,
    handle: { title: PAGE_TITLES.CUSTOMER_PRICING },
  },
  {
    path: "/estimating/pricing/drop-types",
    name: "Drop Types",
    element: <DropTypes />,
    handle: { title: PAGE_TITLES.DROP_TYPES },
  },
  {
    path: "/estimating/pricing/add-drop-types",
    name: "Add Drop Type",
    element: <AddDropType />,
    handle: { title: PAGE_TITLES.ADD_DROP_TYPE },
  },
  {
    path: "/estimating/pricing/drop-types/:id",
    name: "Edit Drop Type",
    element: <AddDropType />,
    handle: { title: PAGE_TITLES.DROP_TYPE },
  },
  {
    path: "/estimating/pricing/pricing-matrix",
    name: "Pricing Matrix",
    element: <PricingMatrix />,
    handle: { title: PAGE_TITLES.PRICING },
  },
  // BIDS
  {
    path: "/estimating/bids",
    name: "Bids",
    exact: true,
    element: <Navigate replace />,
    handle: { title: PAGE_TITLES.BIDS },
  },
  {
    path: "/estimating/bids/",
    name: "Bids",
    element: <Plans />,
    handle: { title: PAGE_TITLES.BIDS },
  },
  {
    path: "/estimating/bids/:accountId",
    exact: true,
    name: "Bid Detail",
    element: <Navigate to="series" replace />,
    handle: { title: PAGE_TITLES.BIDS },
  },
  {
    path: "/estimating/bids/:accountId/:tab",
    name: "Bid Detail",
    element: <PlanDetail />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/:accountId/:tab/:seriesOrCommunityId",
    exact: true,
    name: "Series Details",
    element: <Navigate to="all-bids" replace />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/:accountId/:tab/:seriesOrCommunityId/:seriesOrCommunityTab",
    name: "Series Details",
    element: <PlanSeriesCommunitiesDetail />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/:accountId/:tab/:seriesOrCommunityId/add-bid",
    name: "Add Spec Sheets",
    element: <AddSpecSheet />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/:accountId/:tab/:seriesOrCommunityId/add-bid/:specPlanId",
    name: "Edit Draft Spec Sheets",
    element: <AddSpecSheet />,
    handle: { title: PAGE_TITLES.BID },
  },
  {
    path: "/estimating/bids/:accountId/:tab/:seriesOrCommunityId/bid-import-review/:planId",
    name: "Bid Import Review",
    element: <ImportPlanReview />,
    handle: { title: PAGE_TITLES.BID },
  },
];
